import { useState } from "react";
import { PLANS } from "@/components/market/Plans";
import { Input } from "@/components/ui/input";
import { useI18n } from "@/i18n/I18nContext";

// VIP plan picker: the three plans or a custom app limit → onChange(plan, customApps).
export const VipPlanField = ({ value, customApps, onChange, testId, compact }) => {
  const { t } = useI18n();
  const [plan, setPlan] = useState(value || "standard");
  const [apps, setApps] = useState(customApps ?? "");
  const cls = compact ? "rounded-md border border-neutral-700 bg-black/40 px-2 py-1 text-xs text-white" : "w-full rounded-md border border-neutral-700 bg-black/50 px-3 py-2 text-sm text-white";
  const pick = (p) => {
    setPlan(p);
    if (p !== "custom") onChange(p, null);
    else if (apps) onChange(p, apps);
  };
  return (
    <div className="mt-1 flex min-w-0 max-w-full flex-wrap items-center gap-2">
      <select value={plan} aria-label="plan" className={`min-w-0 max-w-full ${cls}`} data-testid={testId} onChange={(e) => pick(e.target.value)}>
        {PLANS.map((p) => <option key={p.id} value={p.id}>{p.name} ({p.apps})</option>)}
        <option value="custom">{t("plans.customLabel")}</option>
      </select>
      {plan === "custom" && (
        <Input inputMode="numeric" value={apps} placeholder={t("custom.apps")} aria-label={t("custom.apps")} className="h-8 w-28 bg-black/50 text-xs"
          onChange={(e) => setApps(e.target.value)} onBlur={() => apps && onChange("custom", apps)} data-testid={`${testId}-custom-apps`} />
      )}
    </div>
  );
};
